import { ComponentProps } from "./index"
import { useContext } from "react"
import { PresetContext } from "Components/Preset/context"

export function useEmptyItem(props: ComponentProps) {
    const { weekDay, place } = props
    const { setPresetModal } = useContext(PresetContext)
    // 新增母版
    const handleAddPreset = () => {
        setPresetModal({
            show: true,
            text: "添加母版",
            type: "add",
            data: {
                weekDay,
                place,
            },
        })
    }
    return {
        handleAddPreset,
    }
}
